<template>
  <div>
    <b-modal :ref="id" :id="id" :title="$t('organization.duplicate-option.title')" scrollable size="lg" title-class="font-18" v-model="show" @hidden="onHide">
      <div>
        <b-alert show variant="secondary">
          <span v-html="$t('organization.duplicate-option.description', { organization: organization.name })"></span>
        </b-alert>

        <span v-html="$t('organization.duplicate-option.copy-new-name', { organization: organization.name })" class="text-primary"></span>
        <sweet-input v-model="payload.newName" :isValid="!$v.payload.newName.$error" @input="$v.payload.newName.$touch()" type="text" layout="vertical" inputClass="mb-1" />
        <hr />

        <sweet-button @click="duplicate()" :disabled="isDisabled" :loading="isUpdating" variant="primary" icon="bx bx-copy" :block="true">
          <span v-html="$t('organization.duplicate-option.duplicate', { organization: organization.name })"></span>
        </sweet-button>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <sweet-button @click="show = false" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="ml-2">
            {{ $t("common.cancel") }}
          </sweet-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { minLength, required } from "vuelidate/lib/validators";
export default {
  props: { id: { type: String, required: true }, organization: { type: Object, required: true }, vuexStore: { required: false, default: "organization" } },
  data() {
    return {
      payload: { newName: undefined, sourceOrganization: undefined },
      show: false,
    };
  },
  validations: {
    payload: {
      newName: {
        required,
        minLength: minLength(1),
      },
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters[`${this.vuexStore}/isLoading`];
    },
    isUpdating() {
      return this.$store.getters[`${this.vuexStore}/isUpdating`];
    },
    isDisabled() {
      return this.isLoading || this.$v.payload.newName.$error;
    },
  },
  mounted() {
    this.$v.$touch();
  },
  methods: {
    async duplicate() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        this.payload.sourceOrganization = this.organization;
        await this.$store.dispatch(`${this.vuexStore}/duplicate`, this.payload);

        this.$toast.success("'" + this.$options.filters.translate(this.organization.name) + "' " + this.$t("common.duplicate-successful"));
        setTimeout(() => {
          location.reload();
        }, 1500);
      } catch (error) {
        this.handleHttpErrorByStatusCode({
          customMessage: error?.data?.message || "'" + this.$options.filters.translate(this.organization.name) + "' " + this.$t("common.duplicate-fail"),
          timeout: 10000,
        });
      }
    },
    onHide() {
      this.payload = {};
      this.$emit("onHide");
    },
    onSuccess() {
      this.$emit("onSuccess");
    },
  },
};
</script>
